// removed by extract-text-webpack-plugin
module.exports = {"Review":"_3CqpQoSoSc84hkAic-nIlp","source":"a_3XF_aAKcaZU9cXtIn_W","header":"_2sMiZP6aUeXcfJfAHmasVa a_3XF_aAKcaZU9cXtIn_W","hearts":"zgh8j4v-sAAyUlwUGOKhY a_3XF_aAKcaZU9cXtIn_W","headerText":"_3K2HnY6eIkeG5KDeRCixtu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/Review.css
// module id = 293
// module chunks = 8